import { Component } from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-load-mask',
  templateUrl: './load-mask.component.html',
  standalone: true,
  imports: [
    MatProgressSpinner,
  ],
  styleUrls: ['./load-mask.component.scss']
})
export class LoadMaskComponent {

}
